import React from 'react';
import { getSectionContent, getDefaultContent } from '../services/contentService';
import './Hero.css';

const Hero = ({ content = [] }) => {
  // Get hero section content or use default
  const heroSection = getSectionContent(content, 'hero') || getDefaultContent('hero');
  const { mainTitle, subtitle, primaryButton, secondaryButton, backgroundImage } = heroSection.content;

  return (
    <section className="hero" style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}}>
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      <div className="hero-content">
        <div className="container">
          <div className="hero-text">
            <h1 className="hero-title">
              {mainTitle || 'Driving Youth Employment and inclusive economic development across Africa'}
            </h1>
            {subtitle && (
              <p className="hero-subtitle">{subtitle}</p>
            )}
            <div className="hero-buttons">
              {primaryButton && (
                <button 
                  className="btn-primary"
                  onClick={() => window.location.href = primaryButton.link || '#what-we-do'}
                >
                  {primaryButton.text || 'What we do'}
                </button>
              )}
              {secondaryButton && (
                <button 
                  className="btn-secondary"
                  onClick={() => window.location.href = secondaryButton.link || '#video'}
                >
                  {secondaryButton.hasIcon && <span className="play-icon">▶</span>}
                  {secondaryButton.text || 'Play Video'}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
